import React from 'react';
import LandingPage from '../components/perfume/LandingPage';

function PerfumePage() {
  return <LandingPage />;
}

export default PerfumePage;
